import Text from 'components/_UI/Text'
import DynamicProfileImage from 'components/commons/DynamicProfileImage'
import phoneFormatter from 'helpers/phone'
import React from 'react'
import { Phone } from 'lucide-react'
import { Column } from 'styled/alignment/Column'
import { Row } from 'styled/alignment/Row'
import colors from 'theme/colors'

export default function ProducerCard({ data }) {
    function formatPhone(number) {
        const cleaned = number.replace(/\D/g, '');

        if (cleaned.length === 10) {
            return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
        }

        if (cleaned.length === 11) {
            return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
        }

        return number

    }
    return (
        <Row>
            <Column width='auto'>
                <DynamicProfileImage
                    img={data?.profile_image_id?.path}
                    size={'80px'}
                    word={data?.name}
                />
            </Column>

            <Column marginLeft='14px'>
                <Text name='highlight' color={colors.nightDark}>
                    {data?.name}
                </Text>
                <Text>{data?.description}</Text>
                {data?.phone && (
                    <Row marginTop='4px'>
                        <Phone size={'18px'} />
                        <Text marginLeft={'6px'}> {formatPhone(data?.phone)} </Text>
                    </Row>
                )}
            </Column>
        </Row>
    )
}
